import React, { useState } from 'react'
import {
  Form,
  Button,
  Row,
  Col,
  CenteredSpinner,
  FileDropzone
} from 'react-angle-dashboard-components'
import { useMutation } from 'react-query'
import { SmallTitle, FormLabel, FormControl } from '../styles'
import { eligibilityService } from '../../../services'
import { PhoneControl } from '../../../components/PhoneControl/PhoneControl'
import { IGetEligibilityInfoReqBody } from '../../../services/eligibility'

export const TicketForm: React.FC<{
  criteriaData: IGetEligibilityInfoReqBody
  foundResult: boolean
  clearResults: (msg: string) => void
}> = ({ criteriaData, foundResult, clearResults }) => {
  const [filesToUpload, setFilesToUpload] = useState<File[] | undefined>()
  const [requestorName, setRequestorName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [issueContext, setIssueContext] = useState('')
  const [fileDropzoneKey, setFileDropzoneKey] = useState(1)
  const [phoneKey, setPhoneKey] = useState(1)

  const createTicket = useMutation((data: FormData) =>
    eligibilityService.createTicket(data)
  )

  const clearAllInputs = () => {
    setEmail('')
    setPhone('')
    setIssueContext('')
    setFilesToUpload(undefined)
    setRequestorName('')
    setFileDropzoneKey((k) => k + 1)
    setPhoneKey((k) => k + 1)
    clearResults("Thank you, we'll be in touch soon!")
  }

  const onSubmit = async (e: any) => {
    e.preventDefault()

    // TODO send requestor name and any uploaded documents once we have api fields
    const data: any = {}

    data.contact = {
      email
    }

    if (phone) {
      data.contact.phone = phone
    }

    data.criteria = criteriaData

    data.issue = {
      context: issueContext,
      type: foundResult ? "successful" : "unsuccessful"
    }

    data.requestor_name = requestorName

    const formData = new FormData()
    formData.append('data', JSON.stringify(data))

    if (filesToUpload) {
      filesToUpload.forEach((f) => {
        formData.append('file', f, f.name)
      })
    }

    try {
      await createTicket.mutateAsync(formData)
      clearAllInputs()
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <Form className="pt-5" onSubmit={onSubmit}>
      <SmallTitle>
        {foundResult
          ? 'See an issue with a member’s information or have a question about the results? Submit a ticket here.'
          : "Can't find a member? Try one more time, then submit a ticket here."}
      </SmallTitle>
      <Row style={{ paddingRight: 15, paddingLeft: 15, marginBottom: 15 }}>
        <FormLabel>Please provide context for your inquiry:</FormLabel>
        <Form.Control
          as="textarea"
          className="bg-white w-100"
          required
          onChange={(e: any) => setIssueContext(e.target.value)}
          value={issueContext}
        />
      </Row>
      <Row className="mb-5">
        <Col>
          <FormLabel>Upload Documents/Files</FormLabel>
          <FileDropzone
            key={fileDropzoneKey}
            onFileLoaded={(e: File[]) => {
              setFilesToUpload(e)
            }}
          />
        </Col>
      </Row>
      <Row>
        <Col sm={6} xs={12}>
          {' '}
          <Form.Group>
            <FormLabel>Requestor Name</FormLabel>
            <FormControl
              required
              onChange={(e: any) => setRequestorName(e.target.value)}
              value={requestorName}
              placeholder="Requestor Name"
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col sm={6} xs={12}>
          <Form.Group>
            <FormLabel>Email</FormLabel>
            <FormControl
              required
              onChange={(e: any) => setEmail(e.target.value)}
              value={email}
              placeholder="Please enter an email address"
            />
          </Form.Group>
        </Col>
        <Col sm={6} xs={12}>
          <Form.Group>
            <FormLabel>Phone (optional)</FormLabel>
            <PhoneControl
              key={phoneKey}
              onChange={(value: string) => setPhone(value)}
              placeholder="Please enter a phone number"
            />
          </Form.Group>
        </Col>
      </Row>
      <Button className="my-3 py-2" type="submit">
        Submit
      </Button>
      {createTicket.isLoading && <CenteredSpinner />}
      {createTicket.isError && (
        <Col
          className="mt-5 py-3 px-4 fs-20"
          sm={6}
          xs={12}
          style={{ background: 'rgba(237, 76, 120, 0.1)', borderRadius: 6 }}
        >
          {' '}
          An unexpected error occurred creating your ticket. Please reach out to
          our Care Team by phone at +1 (855) 937-1811.
        </Col>
      )}
    </Form>
  )
}
